import { render } from "./JobProjectionTable.vue?vue&type=template&id=1cfb4cd2&ts=true"
import script from "./JobProjectionTable.vue?vue&type=script&lang=ts"
export * from "./JobProjectionTable.vue?vue&type=script&lang=ts"

import "./JobProjectionTable.vue?vue&type=style&index=0&id=1cfb4cd2&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__